<template>
	<div class="Authority">
		<div class="TopSearch">
			<FromComm :FromArr="FromArr"></FromComm>
			<div>
				<CommonBtngroup ref="btngroup" :qhide="false" :chackbox="userInfo && userInfo.IsSaler === 1?false:true"
					checktitle="待我审批" @showclick="showclick" @hide="hide" @select="select" @reset="reset">
				</CommonBtngroup>
			</div>
		</div>
		<div class="BottomTable">
			<div style="display: inline-block;">
				<!--  -->
				<Commonbtn v-if="qx.add" backgroundColor="#FFF" title="新增" fontSize="14px" @btnclick="add"
					:src="require('@/assets/icon/icon-add.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn v-if="qx.update" backgroundColor="#FFF" title="修改" fontSize="14px" @btnclick="update('edit')"
					:src="require('@/assets/icon/icon-update.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn backgroundColor="#FFF" :src="require('@/assets/icon/look.png')" title="查看" fontSize="14px"
					@btnclick="update('look')" :optional="DataListOK.length !== 1">
				</Commonbtn>
			</div>

			<div style="display: inline-block;">
				<Commonbtn v-if="qx.del" backgroundColor="#FFF" title="删除" fontSize="14px" @btnclick="del"
					:src="require('@/assets/icon/icon-del.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<CommonbtnUpLoad v-if="qx.add" backgroundColor="#FFF" title="导入" fontSize="14px"
					@getFile="InvoiceImport" :src="require('@/assets/icon/icon-drjys.png')">
				</CommonbtnUpLoad>
			</div>
			<div style="display: inline-block;">
				<Commonbtn backgroundColor="#FFF" title="导出" fontSize="14px" @btnclick="AppExport"
					:src="require('@/assets/icon/daoc.png')">
				</Commonbtn>
			</div>
			<!---->
			<div style="display: inline-block;">
				<Commonbtn backgroundColor="#FFF" v-if="qx.download" title="批量下载" fontSize="14px"
					@btnclick="DownloadAll" :src="require('@/assets/channel/all-download.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn backgroundColor="#FFF" v-if="qx.submit" title="提交" fontSize="14px" @btnclick="SubmitApply"
					:src="require('@/assets/channel/Submit.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn backgroundColor="#FFF" title="撤回" v-if="qx.submit" fontSize="14px" @btnclick="Withdraw"
					:src="require('@/assets/channel/withdraw.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn backgroundColor="#FFF" v-if="qx.approval&&userInfo && userInfo.IsSaler === 0" title="审批通过"
					fontSize="14px" @btnclick="Approved" :src="require('@/assets/channel/Approved.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn backgroundColor="#FFF" v-if="qx.approval&&userInfo && userInfo.IsSaler === 0" title="审批驳回"
					fontSize="14px" @btnclick="Rejectapproval" :src="require('@/assets/channel/Rejectapproval.png')">
				</Commonbtn>
			</div>
			<div style="display: inline-block;">
				<Commonbtn backgroundColor="#FFF" title="审批流程" fontSize="14px" @btnclick="Approvalprocess"
					:src="require('@/assets/channel/Approvalprocess.png')">
				</Commonbtn>
			</div>
			<a class="Dowload" style="top:0px;" @click="SeconDowload">下载授权申请导入模版</a>

			<div class="Table">
				<Commontable ref="refTableCenter" @handleSelectionChange="handleSelectionChange"
					@onRowClick="onRowClick" width="1000px" colnum=522 :tableData="tableData" :headerData="headerData"
					height="100%">
				</Commontable>
				<div class="pagination">
					<Pagination ref="invPagination" type='allColor' :pageSize="pageSize"
						@handleCurrentChange="handleCurrentChange" @handleSizeChange="handleSizeChange" :total="total">
					</Pagination>
				</div>
			</div>
			<div class="TableBottom" v-show="tableDataBottom.length > 0">
				<div class="TBlabel">
					授权书
				</div>
				<div>
					<Commontable width="1000px" colnum=7 :tableData="tableDataBottom" :headerData="headerDataBottom"
						height="100%">
					</Commontable>
				</div>
			</div>
		</div>
		<DialogFrom width="1000px" :title="TitleEditor" :OKASCAN="TitleEditor === '查看授权申请'?false:true"
			:dialogVisible="dialogVisibAuthorizationsAdd" @cancel="cancelAuthorizationsAdd"
			@dialogOK="dialogOKAuthorizationsAdd">
			<div class="fixed-model" v-if="TitleEditor === '查看授权申请'"></div>
			<FromComm :FromArr="FromArrEditor" @remoteMethod="remoteMethod"
				@AuthorizedDealerChange="AuthorizedDealerChange" @OrderAuthorizedChange="OrderAuthorizedChange"
				@invClassChange="invClassChange" @selectChange="handSelectChange"></FromComm>
			<!---->
			<FormUpload v-if="NeedUpload" :FromUploadSetting="FromUploadSettingFileRel" @getFiles="RelFileClick">
			</FormUpload>
			<!-- 仅授权说明文件 -->
			<PicturesType style="z-index: 12;" v-if="FromUploadList.length" @See="See"
				:PicturesTypeData="FromUploadList" />
			<div class="line">
			</div>
			<div>
				<div>
					<Commonbtn backgroundColor="#FFF" :src="require('@/assets/icon/icon-add.png')"
						:optional="addClickRowOptional" top="238px" opwidth="88px" title="新增行" fontSize="14px"
						@btnclick="addClickRow">
					</Commonbtn>
					<Commonbtn backgroundColor="#FFF" :src="require('@/assets/icon/del-j.png')" title="删除行"
						:optional="delClickRowOptional" top="238px" opwidth="88px" fontSize="14px"
						@btnclick="delClickRow">
					</Commonbtn>
				</div>
				<Commontable ref="refTableCenterApply" :loadingTable="loadingTableEditor"
					@handleSelectionChange="handleSelectionChangeEditor" @onRowClick="onRowClickEditor" width="1000px"
					colnum=522 :tableData="tableDataEditor" :headerData="headerDataEditor" height="100%">
				</Commontable>
			</div>
		</DialogFrom>

		<DialogFrom width="1000px" title="选择医院" :OKASCAN="true" :dialogVisible="dialogVisibAuthorizationsAddHP"
			@cancel="cancelAuthorizationsAddHP" @dialogOK="dialogOKAuthorizationsAddHP">
			<div>
				<FromComm :FromArr="FromArrHP" @City="City" @Province="Province"></FromComm>
				<div style="margin-top: 20px;margin-bottom: 84px;margin-right: 40px;">
					<CommonBtngroup ref="btngroup" :qhide="false" @showclick="showclickHP" @hide="hideHP"
						@select="selectHP" @reset="resetHP"></CommonBtngroup>
				</div>
			</div>
			<div>
				<Commontable ref="refTableCenterHP" :loadingTable="loadingTableHP"
					@handleSelectionChange="handleSelectionChangeEditorHP" @onRowClick="onRowClickHP" width="1000px"
					colnum=522 :tableData="tableDataEditorHP" :headerData="headerDataEditorHP" height="100%">
				</Commontable>
				<div class="pagination">
					<Pagination ref="invPagination" type='allColor' @handleCurrentChange="handleCurrentChangeHP"
						@handleSizeChange="handleSizeChangeHP" :total="totalHP" :pageSize="pageSizeHP"></Pagination>
				</div>
			</div>
		</DialogFrom>
		<DialogFrom width="890px" :title="title" :dialogVisible="dialogVisiblesdrjg" @cancel="canceldrjg"
			@dialogOK="dialogOKdrjg">
			<div class="from">
				<Commontable @onRowClick="onRowClick" width="830px" colnum=100 :tableData="tableDatadrjg" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<DialogFrom width="890px" title="驳回原因" :dialogVisible="dialogVisibleReject" @cancel="cancelReject"
			@dialogOK="dialogOKReject">
			<div style="margin-left: -20px;">
				<el-input type="textarea" :rows="2" placeholder="请输入驳回原因" v-model="RejectText">
				</el-input>
			</div>
		</DialogFrom>
		<DialogFrom width="890px" title="审批流程" :dialogVisible="dialogVisibleApprovalprocess"
			@cancel="cancelApprovalprocess" @dialogOK="dialogOKApprovalprocess">

			<div class="from">
				<Commontable width="1000px" colnum=7 :loadingTable="loadingTableprocess"
					:tableData="ApprovalprocessTableData" :headerData="ApprovalprocessheaderData" height="100%">
				</Commontable>
			</div>
		</DialogFrom>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleSubmit" @cancel="cancelSubmit"
			@dialogOK="dialogOKSubmit" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要提交该数据吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisiblewithdraw" @cancel="cancelwithdraw"
			@dialogOK="dialogOKwithdraw" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要撤回该数据吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleApproved" @cancel="cancelApproved"
			@dialogOK="dialogOKApproved" :src="require('@/assets/icon/icon-errors.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要审批通过该数据吗？</span>
		</Dialog>
		<Dialog width="420px" title="提示信息" :dialogVisible="dialogVisibleDel" @cancel="cancelDel" @dialogOK="dialogOKDel"
			:src="require('@/assets/icon/icon-del2.png')">
			<span
				style="display: inline-block;position: absolute; top: 50px; left: 50px; font-size: 14px;color: #666666;">确认要删除该数据吗？</span>
		</Dialog>
	</div>
</template>

<script>
	import FormUpload from '@/components/comm-fromUpload.vue'
	import FromComm from '../../../components/fromComponents/Commfrom/from-comm.vue'
	import CommonBtngroup from '../../../../../../components/commongroup.vue'
	import Commonbtn from '../../../../../../components/common-btn.vue'
	import CommonbtnUpLoad from '../../../../../../components/common-upload.vue'
	import Commontable from '../../../../../../components/common-table.vue'
	import Pagination from '../../../../../../components/pagination.vue'
	import DialogFrom from '../../../../../../components/dialog-from.vue'
	import Dialog from '../../../../../../components/dialog.vue'
	import FromArr from './FromData/FromArr'
	import headerData from './headerData/headerData'
	import headerDataEditor from './headerData/headerDataEditor'
	import headerDataEditorHP from './headerData/headerDataEditorHP'
	import headerDataBottom from './headerData/headerDataBottom'
	import ApprovalprocessheaderData from './headerData/ApprovalprocessheaderData'
	import FromArrEditor from './FromData/FromArrEditor'
	import FromArrHP from './FromData/FromArrHP'
	import utils from '../../../../../../common/utils'
	import PicturesType from './components/PicturesType.vue'
	import {
		APPBusinessAuthorityList,
		APPBusinessAuthorityAdd,
		APPBusinessAuthorityInfo,
		APPBusinessAuthorityEdit,
		APPBusinessAuthorityDelete,
		APPBusinessAuthorityExport,
		HelperApprovalFlowStatus,
		APPBusinessAuthoritySubmit,
		APPBusinessAuthorityReject,
		APPBusinessAuthorityApprove,
		APPBusinessAuthorityGetHostory,
		APPBusinessAuthorityRevoke,
		BusinessAuthorityGeneratePdfList,
		BusinessAuthorityPrintPdfList,
		HelperSalesMan,
		GetProductDetail,
		APPBusinessAuthorityDownloadTemplet,
		ImportAPPBusinessAuthority,
		GetHelperDispatcherType
	} from '@/api/channel'
	import {
		HospitalList,
		CustomerList,
		GetHospitalType,
		InventoryClassList,
		UserInfoByInvClass,
		GetProvince,
		GetCity,
		GetDistrict,
		ProductList,
		NeedUploadDocumentation,
		UpLoadAttachmentAuthority
	} from '@/api/home'
	export default {
		components: {
			FormUpload,
			FromComm,
			CommonBtngroup,
			Commonbtn,
			Commontable,
			Pagination,
			DialogFrom,
			CommonbtnUpLoad,
			Dialog,
			PicturesType
		},
		props: {},
		data() {
			return {
				FromUploadList: [],
				NeedUpload: false,
				FromUploadSettingFileRel: {
					title: "说明文件上传：",
					inputtype: "upload",
					uploadTitle: "上传附件或图片",
					inputflag: true,
					fontSize: 14,
					color: "#333333",
					lableheight: 20,
					X: false,
					placeholder: "请输入",
					width: 300,
					height: 32,
					disabled: false,
					marginLeft: 0,
					marginTop: 30,
					displayVal: "inline-block",
					fontWeightVal: 500,
					multiple: true,
					accept: "*",
					ClickName: 'FileClick',
					backgroundColor: "#fafbfc",
					uploadColor: "rgb(111 113 115)"
				},
				dialogVisibAuthorizationsAdd: false,
				dialogVisibAuthorizationsAddHP: false,
				dialogVisiblesdrjg: false,
				dialogVisibleSubmit: false,
				dialogVisibleReject: false,
				dialogVisibleApproved: false,
				dialogVisibleApprovalprocess: false,
				dialogVisiblewithdraw: false,
				GCTQORGCYL: false,
				dialogVisibleDel: false,
				addClickRowOptional: false, //控制编辑新增数据是否可点击
				delClickRowOptional: false, //控制编辑删除数据是否可点击
				AppEditorFalg: false, //控制新增数据提交状态(空 false 否则 true)
				loadingTableEditor: false,
				loadingTableHP: false,
				loadingTableprocess: false,
				InvClass: '',
				invClassRow: '',
				title: '',
				TitleEditor: '',
				ProviderID: '',
				ProviderName: '',
				CusCode: '',
				CusName: '',
				RejectText: '',
				BAMID: null,
				BAMIDs: [],
				PageIndex: 1,
				pageSize: 10,
				total: 0,
				totalHP: 0,
				pageSizeHP: 10,
				pageIndexHP: 1,
				headerDataBottom: [],
				tableDataBottom: [],
				headerDataEditor: [],
				tableDataEditor: [], //医院选中数据进行过滤后的数据
				TableDataEditorDataOK: [], //医院选中数据
				EditorTabelData: [], //编辑授权申请弹窗表格选中数据
				tableDatadrjg: [],
				DataListOK: [],
				FromArr: [],
				FromArrEditor: [],
				FromArrHP: [],
				headerData: [],
				tableData: [],
				tableDataEditorHP: [],
				headerDataEditorHP: [],
				ApprovalprocessheaderData: [],
				ApprovalprocessTableData: [],
				StyleCss: {
					position: 'relative',
					left: -930,
					right: -62,
					opacityGCTQ: 1,
					opacityGQYL: 0
				},
				from: {
					ProviderName: '',
					CusName: '',
					AuthorityCode: '',
					InvClass: '',
					Status: '',
					CreateTime1: '',
					CreateTime2: '',
					MyApproval: '',
					HPName: '',
					ApplyCode: '',
					ID: ''
				},
				fromHP: {
					hpCode: "",
					hpName: "",
					HosType: "",
					CreateTime1: "",
					CreateTime2: "",
					authorizeStatus: "",
					aProvinceID: "",
					aCityID: "",
					aDistrictID: "",
				},
				qx: {
					add: false,
					update: false,
					del: false,
					stopif: true,
					daoc: true,
					assignment: false,
					enabled: false,
					submit: false,
					skip: false, //跳过
					reset: false, //重置
					revoke: false, //弃审
					changeth: false, //弃审
					approval: false, //驳回OR审批通过
					download: false,
				},
				chackbox: true,
			}
		},
		computed: {
			userInfo() {
				return this.$store.state.MenusData;
			}
		},
		created() {
			this.APPBusinessAuthorityList()
			this.inventoryClassList()
			this.HelperApprovalFlowStatus()
			this.GetProvince()
			///this.getHelperDispatcherType();
		},
		mounted() {
			this.FromArr = JSON.parse(JSON.stringify(FromArr))
			this.FromArrEditor = JSON.parse(JSON.stringify(FromArrEditor))
			this.FromArrHP = JSON.parse(JSON.stringify(FromArrHP))
			this.headerData = JSON.parse(JSON.stringify(headerData))
			this.headerDataEditor = JSON.parse(JSON.stringify(headerDataEditor))
			this.headerDataEditorHP = JSON.parse(JSON.stringify(headerDataEditorHP))
			this.headerDataBottom = JSON.parse(JSON.stringify(headerDataBottom))
			this.ApprovalprocessheaderData = JSON.parse(JSON.stringify(ApprovalprocessheaderData))

			// if (this.userInfo && this.userInfo.IsSaler === 1) {
			// 	this.FromArr[5].hidden = true;
			// }
			//this.QX()
		},
		activated() {},
		updated() {},
		methods: {
			QX() {
				let qus = []
				let data = JSON.parse(localStorage.getItem("MenusData"))
				data.CusWebMenus.map((item, index) => {
					if (item.NodeID == 77) {
						item.Nodes.map((items, indexs) => {
							if (items.NodeID == 80) {
								items.Nodes.map((itemes, indexes) => {
									if (itemes.NodeID == 85) {
										qus = itemes.Nodes
									}
								})
							}
						})
					}
				})
				console.log(this.qus, "this.qus");
				if (qus && qus.length) {
					qus.map((item, index) => {
						if (item.NodeName == 'add') {
							this.qx.add = true
						} else if (item.NodeName == 'edit') {
							this.qx.update = true
						} else if (item.NodeName == 'delete') {
							this.qx.del = true
						} else if (item.NodeName == 'stopif') {
							this.qx.del = true
						} else if (item.NodeName == 'assignment') {
							this.qx.assignment = true
						} else if (item.NodeName == 'enabled') {
							this.qx.enabled = true
						} else if (item.NodeName == 'skip') {
							this.qx.skip = true
						} else if (item.NodeName == 'reset') {
							this.qx.reset = true
						} else if (item.NodeName == 'changeth') {
							this.qx.changeth = true
						} else if (item.NodeName == 'Download') {
							this.qx.download = true
						}
					})
				}
			},
			// 查询配送商类型
			async getHelperDispatcherType() {
				let {
					data,
					code,
					message
				} = await GetHelperDispatcherType({})
				if (code == 0) {
					this.headerDataEditor[4].options = []
					data.map((item, index) => {
						let obj = {
							key: String(item.Value),
							value: item.Text
						}
						this.headerDataEditor[4].options.push(obj)
					})
				} else {
					this.$message.error(message);
				}
			},
			// 省
			async GetProvince() {
				let {
					data,
					code,
					message
				} = await GetProvince({})
				if (code == 0) {
					this.FromArrHP[4].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.FromArrHP[4].options.push(obj)
					})
				} else {
					this.$message({
						type: 'error',
						message: "省份列表加载失败"
					})
				}
			},
			Province(e) {
				this.getcity(e.FromArr[4].modelvalue)
			},
			City(e) {
				this.getDistrict(e.FromArr[5].modelvalue)
			},
			// 市
			async getcity(provinceid) {
				this.FromArrHP[5].modelvalue = ''
				this.FromArrHP[6].modelvalue = ''
				let params = {
					ProvinceID: provinceid
				}
				let {
					code,
					data
				} = await GetCity({
					params
				})
				if (code == 0) {
					this.FromArrHP[5].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.FromArrHP[5].options.push(obj)
					})
				}
			},
			// 区
			async getDistrict(cityID) {
				this.FromArrHP[6].modelvalue = ''
				let params = {
					CityID: cityID
				}
				let {
					code,
					data
				} = await GetDistrict({
					params
				})
				if (code == 0) {
					this.FromArrHP[6].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.FromArrHP[6].options.push(obj)
					})
				}
			}, //负责销售
			async getHelperSalesMan() {
				let {
					code,
					data
				} = await HelperSalesMan({})
				if (code == 0) {
					this.FromArrEditor[7].options = data;
				}
			},
			// 列表
			async APPBusinessAuthorityList() {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let {
					code,
					message,
					data
				} = await APPBusinessAuthorityList({
					ProviderName: this.from.ProviderName,
					CusName: this.from.CusName,
					AuthorityCode: this.from.AuthorityCode,
					InvClass: this.from.InvClass,
					Status: this.from.Status,
					CreateTime1: this.from.CreateTime1,
					CreateTime2: this.from.CreateTime2,
					MyApproval: this.from.MyApproval,
					HPName: this.from.HPName,
					ApplyCode: this.from.ApplyCode,
					ID: this.from.ID,
					pageIndex: this.PageIndex,
					pageSize: this.pageSize,
				})

				if (code == 0) {
					this.total = data.Count
					this.tableData = data.data.map((item, index) => {
						item.ID = index;
						return item;
					})
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			// 导出
			async APPBusinessAuthorityExport() {
				const loading = this.$loading({
					lock: true,
					text: '正在导出...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let resexprot = await APPBusinessAuthorityExport({
					ProviderName: this.from.ProviderName,
					CusName: this.from.CusName,
					AuthorityCode: this.from.AuthorityCode,
					InvClass: this.from.InvClass,
					Status: this.from.Status,
					CreateTime1: this.from.CreateTime1,
					CreateTime2: this.from.CreateTime2,
					MyApproval: this.from.MyApproval,
					HPName: this.from.HPName,
				})
				if (resexprot) {
					let date = new Date()
					let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
					utils.downloadFile(resexprot, `授权申请导出${str}`, "xlsx")
				} else {
					// 返回json
					this.$message.warning('导出失败');
				}
				loading.close()
			},
			// 导出事件调用接口
			AppExport() {
				console.log("导出");
				this.APPBusinessAuthorityExport()
			},
			// 新增
			async APPBusinessAuthorityAdd(IsForce = 0) {
				// console.log(this.tableDataEditor);
				// return;
				if (!this.AppEditorFalg) {
					this.$message.warning(`${this.FromArrEditor[0].title}和${this.FromArrEditor[1].title}不能为空！`)
					return
				}
				if (!this.FromArrEditor[7].modelvalue) {
					this.$message.warning(`申请理由不能为空！`)
					return
				}
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let params = {
					InvClass: this.FromArrEditor[0].modelvalue,
					ProviderID: this.FromArrEditor[1].modelvalue,
					CusCode: this.FromArrEditor[2].modelvalue,
					StartDate: this.FromArrEditor[5].StartTime,
					EndDate: this.FromArrEditor[5].EndTime,
					Remark: this.FromArrEditor[7].modelvalue,
					NeedBossApproval: 0,
					listPDCode: this.FromArrEditor[3].modelvalue,
					lstHospitalInPuts: this.tableDataEditor,
					ListInventory: this.FromArrEditor[4].modelvalue,
					listAttatchment: this.FromUploadList.length ? this.FromUploadList.map(it => it.FileName) : [],
					//SalesMan: this.FromArrEditor[7].modelvalue, //负责销售
				};
				if (IsForce) {
					params.IsForce = IsForce;
				}
				let {
					code,
					message,
					data
				} = await APPBusinessAuthorityAdd(params);
				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibAuthorizationsAdd = false
					this.APPBusinessAuthorityList()
					this.FromUploadList = [];
				} else if (code == 201) {
					this.$confirm('存在重复,是否还要保存?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.APPBusinessAuthorityAdd(1);
					}).catch(() => {});
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			// 修改授权申请
			async APPBusinessAuthorityEdit(IsForce = 0) {
				if (!this.FromArrEditor[7].modelvalue) {
					this.$message.warning(`申请理由不能为空！`)
					return
				}
				let params = {
					BAMID: this.BAMID,
					InvClass: this.FromArrEditor[0].modelvalue,
					ProviderID: this.FromArrEditor[1].modelvalue == this.ProviderName ? this.ProviderID : this
						.FromArrEditor[1].modelvalue,
					CusCode: this.FromArrEditor[2].modelvalue == this.CusName ? this.CusCode : this
						.FromArrEditor[2].modelvalue,
					StartDate: this.FromArrEditor[5].StartTime,
					EndDate: this.FromArrEditor[5].EndTime,
					Remark: this.FromArrEditor[7].modelvalue,
					NeedBossApproval: 0,
					listPDCode: this.FromArrEditor[3].modelvalue,
					lstHospitalInPuts: this.tableDataEditor,
					ListInventory: this.FromArrEditor[4].modelvalue,
					listAttatchment: this.FromUploadList.length ? this.FromUploadList.map(it => it.FileName) : [],
					//SalesMan: this.FromArrEditor[7].modelvalue, //负责销售
				}
				if (IsForce) {
					params.IsForce = IsForce;
				}
				let {
					code,
					message,
					data
				} = await APPBusinessAuthorityEdit(params);
				if (code == 0) {
					this.dialogVisibAuthorizationsAdd = false
					this.APPBusinessAuthorityList()
					this.$message.success(message)
					this.FromUploadList = [];
				} else if (code == 201) {
					this.$confirm('存在重复,是否还要保存?', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						this.APPBusinessAuthorityEdit(1);
					}).catch(() => {});
				} else {
					this.$message.error(message)
				}
			},
			// 详情
			async APPBusinessAuthorityInfo(type) {
				// const loading = this.$loading({
				// 	lock: true,
				// 	text: '加载中...',
				// 	spinner: 'el-icon-loading',
				// 	background: 'rgba(255,255,255,0.3)'
				// });
				let {
					code,
					data,
					message
				} = await APPBusinessAuthorityInfo({
					BAMID: this.BAMID
				})
				if (code == 0) {
					if (type == 'INFO') {
						this.FromArrEditor[0].modelvalue = data.data.InvClass
						this.FromArrEditor[1].modelvalue = data.data.ProviderName
						this.FromArrEditor[2].modelvalue = data.data.CusName
						this.FromArrEditor[3].modelvalue = data.data.ListPDCode
						this.FromArrEditor[4].modelvalue = data.data.ListInventory.map(it => it.KeyCode);
						this.FromArrEditor[5].StartTime = data.data.StartDate
						this.FromArrEditor[5].EndTime = data.data.EndDate
						this.FromArrEditor[6].checked = false // data.data.NeedBossApproval == 1 ? true : false
						this.FromArrEditor[7].modelvalue = data.data.Remark
						//this.FromArrEditor[7].modelvalue = data.data.SalesMan //负责销售
						this.tableDataEditor = data.data.lstHospitalOutPuts.map(it => {
							it.DispatcherType = String(it.DispatcherType);
							return it;
						})
						this.ProductList(data.InvClass)
						this.ProviderID = data.data.ProviderID
						this.CusCode = data.data.CusCode
						this.ProviderName = data.data.ProviderName
						this.CusName = data.data.CusName
						//this.ListAttatchment = data.data.ListAttatchment
						if (data.data.ListAttatchment) {
							this.FromUploadList = data.data.ListAttatchment.map(it => {
								it.FileName = it.ImageTypeName || it.ImagePath;
								it.ImageUrl = it.ImageUrlPath;
								return it;
							})
						}

						if (data.data.CusName != data.data.ProviderName) {
							this.NeedUpload = true;
						}
						if (this.TitleEditor === '查看授权申请') {
							this.addClickRowOptional = true;
							this.delClickRowOptional = true;
						}

						// 匹配全选
						if (data.data.ListPDCode.length == this.FromArrEditor[3].options.length) {
							this.FromArrEditor[3].checkedSelect = true
						} else {
							this.FromArrEditor[3].checkedSelect = false
						}
						this.getProduct(data.data.ListInventory);
						this.dialogVisibAuthorizationsAdd = true
						console.log('--------->', this.headerDataEditor);
					}
					if (type == 'BottomTableSee') {
						this.tableDataBottom = data.data.lstHospitalOutPuts.map(it => {
							it.DispatcherType = String(it.DispatcherType);
							return it;
						})
					}

				} else {
					this.$message.error("请选择操作的数据！")
				}
				//loading.close()
			},
			// 删除授权申请
			async APPBusinessAuthorityDelete() {
				let BAMIDs = []
				this.DataListOK.forEach((item, index) => {
					BAMIDs.push(item.BAMID);
				})
				let {
					code,
					message,
					data
				} = await APPBusinessAuthorityDelete({
					BAMIDs: BAMIDs,
				})

				if (code == 0) {
					this.$message.success(message)
					this.dialogVisibleDel = false
					this.APPBusinessAuthorityList()
					// this.title = "删除结果"
					// this.dialogVisiblesdrjg = true
					// this.tableDatadrjg = data
					this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection()
				} else {
					this.$message.warning(message)
				}
			},
			// 授权经销商(AutoComplete)
			async HospitalList(type, query, HosType) {
				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});

				this.FromArrEditor[1].loading = true
				let hpName = ""
				if (type == "AutoCompleteList") {
					hpName = query
				}
				if (type == "DialogFromList") {
					hpName = this.fromHP.hpName
					this.loadingTableHP = true
				}

				let params = {
					hpName: hpName,
					//HosType: HosType,
					hpCode: this.fromHP.hpCode,
					authorizeStatus: this.fromHP.authorizeStatus,
					// HosType: this.fromHP.HosType,
					// CreateTime1: this.fromHP.CreateTime1,
					// CreateTime2: this.fromHP.CreateTime2,
					ProvinceID: this.fromHP.aProvinceID,
					CityID: this.fromHP.aCityID,
					DistrictID: this.fromHP.aDistrictID,
					pageSize: this.pageSizeHP,
					pageIndex: this.pageIndexHP
				}

				if (type == "AutoCompleteList") {
					params.IsTXCus = 1;
				}
				if (type == "DialogFromList") {
					params.HosType = HosType;
					params.IncludeCity = '1';
				}

				let {
					code,
					message,
					data
				} = await HospitalList(params)

				if (code == 0) {
					if (type == "AutoCompleteList") {
						this.FromArrEditor[1].options = []
						data.data.map((item, index) => {
							let obj = {
								value: item.HPID,
								label: item.HPName,
							}
							this.FromArrEditor[1].options.push(obj)
						})
					}
					if (type == "DialogFromList") {
						this.totalHP = data.Count
						this.tableDataEditorHP = data.data
						this.dialogVisibAuthorizationsAddHP = true

					}
				} else {
					this.$message.warning(message)
				}
				this.loadingTableHP = false
				this.FromArrEditor[1].loading = false
				loading.close()
			},
			// 订货经销商(AutoComplete)
			async CustomerList(query) {
				this.FromArrEditor[2].loading = true
				let {
					code,
					message,
					data
				} = await CustomerList({
					CusName: query,
					IsOrderCustomer: '1'
				})
				if (code == 0) {
					this.FromArrEditor[2].options = []
					data.data.map((item, index) => {
						let obj = {
							value: item.CusCode,
							label: item.CusName,
						}
						this.FromArrEditor[2].options.push(obj)
					})
				} else {
					this.$message.warning(message)
				}
				this.FromArrEditor[2].loading = false
			},
			// AutoComplete事件
			remoteMethod(val, par) {
				console.log(val, par, 'methodName');
				if (val.parsign == 'AuthorizedDealer') {
					this.HospitalList('AutoCompleteList', val.qurey, "")
				} else if (val.parsign == 'OrderingDealer') {
					this.CustomerList(val.qurey)
				}
			},
			// 授权产品下拉数据
			async ProductList(InvClass) {
				let {
					code,
					message,
					data
				} = await ProductList({
					InvClass: InvClass
				})
				if (code == 0) {
					this.FromArrEditor[3].options = []
					data.data.map((item, index) => {
						let obj = {
							key: item.PDCode,
							value: item.ShowNameForCombo
						}
						this.FromArrEditor[3].options.push(obj)
					})
				}
			},
			// 授权申请弹窗，公司下拉的change事件
			invClassChange(e) {
				if (this.TitleEditor == '新增授权申请') {
					console.log(this.FromArrEditor[1].modelvalue, 'this.FromArrEditor[1].modelvalue');
					if (this.FromArrEditor[0].modelvalue != '' && this.FromArrEditor[1].modelvalue != '') {
						this.FromArrEditor.forEach((item, index) => {
							if (index != 0 && index != 1) {
								item.disabled = false
							}
						})
						this.addClickRowOptional = false
						this.delClickRowOptional = false
						this.AppEditorFalg = true
					} else {
						this.FromArrEditor.forEach((item, index) => {
							if (index != 0 && index != 1) {
								item.disabled = true
							}
						})
						this.addClickRowOptional = true
						this.delClickRowOptional = true
						this.AppEditorFalg = false
					}
				}
				this.ProductList(e.FromArr[0].modelvalue)

			},
			AuthorizedDealerChange(e) {
				console.log(e, 'AuthorizedDealerChange');
				if (this.TitleEditor == '新增授权申请') {
					if (this.FromArrEditor[0].modelvalue != '' && this.FromArrEditor[1].modelvalue != '') {
						this.FromArrEditor.forEach((item, index) => {
							if (index != 0 && index != 1) {
								item.disabled = false
							}
						})
						this.addClickRowOptional = false
						this.delClickRowOptional = false
						this.AppEditorFalg = true
					} else {
						this.FromArrEditor.forEach((item, index) => {
							if (index != 0 && index != 1) {
								item.disabled = true
							}
						})
						this.addClickRowOptional = true
						this.delClickRowOptional = true
						this.AppEditorFalg = false
					}
				}
			},
			OrderAuthorizedChange(e) {
				console.log(e, 'OrderAuthorizedChange');
			},
			handSelectChange(e) {
				if (e === 3) {
					this.getProduct();
				}

				if (e === 1 || e === 2) {
					this.isUploadFile();
				}
			},
			async isUploadFile() {
				///新增逻辑
				let val1Name = '',
					val2Name = '';

				let obj1 = this.FromArrEditor[1];
				val1Name = obj1.options.length ? obj1.options.filter(it => it.value === obj1.modelvalue)[0].label : '';
				let obj2 = this.FromArrEditor[2];
				val2Name = obj2.options.length ? obj2.options.filter(it => it.value === obj2.modelvalue)[0].label : '';

				if (val1Name && val2Name && val1Name != val2Name) {
					console.log('========>我们不同', val1Name, val2Name);
					let {
						code,
						data
					} = await NeedUploadDocumentation({
						ProviderID: this.FromArrEditor[1].modelvalue,
						CusCode: this.FromArrEditor[2].modelvalue,
					})
					if (data == 1) {
						this.NeedUpload = true;
						console.log('可以增加上传')
					}
				}
			},
			async RelFileClick(file) {
				console.log(file, 'FileClick');
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '正在上传...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formdata = new FormData()
					for (var i = 0; i < file.length; i++) {
						formdata.append("files", file[i]);
					}
					let {
						data,
						code,
						message
					} = await UpLoadAttachmentAuthority(formdata)
					if (code == 0) {
						this.FromUploadList = data;

						this.$message({
							type: 'success',
							message: message
						});
						loading.close();
					} else {
						this.$message({
							type: 'warning',
							message: message
						});
						loading.close();
					}
				}
			},
			See(e) {
				window.open(e.ImageUrl, '_blank');
			},
			async getProduct(e) {
				let {
					code,
					data
				} = await GetProductDetail({
					CanChooseBySaler: '1',
					PDCode: this.FromArrEditor[3].modelvalue.join(',')
				})
				if (code == 0) {
					this.FromArrEditor[4].options = []
					data.map((item, index) => {
						let obj = {
							key: item.KeyCode,
							value: item.ShowName
						}
						this.FromArrEditor[4].options.push(obj);
					})
					if (e && e.length == this.FromArrEditor[4].options.length) {
						this.FromArrEditor[4].checkedSelect = true
					} else {
						this.FromArrEditor[4].checkedSelect = false
					}
					if (!data.length) {
						this.FromArrEditor[4].modelvalue = '';
					}
				}
			},
			// 客服分类
			async GetHospitalType() {
				let {
					code,
					data
				} = await GetHospitalType({

				})
				if (code == 0) {
					this.FromArrHP[3].options = []
					data.map((item, index) => {
						let obj = {
							key: index,
							value: item.Name
						}
						this.FromArrHP[3].options.push(obj)
					})
				}
			},
			add() {
				this.TitleEditor = '新增授权申请'
				this.dialogVisibAuthorizationsAdd = true
				//this.getHelperSalesMan();
			},
			update(e) {
				if (this.DataListOK.length === 1) {
					this.BAMID = this.DataListOK[0].BAMID;
				}
				if (!this.BAMID) {
					this.$message.error("请选择一条数据")
					return
				}
				this.TitleEditor = e === 'edit' ? '修改授权申请' : '查看授权申请';
				this.APPBusinessAuthorityInfo("INFO")
				//this.getHelperSalesMan();
			},
			del() {
				if (this.DataListOK.length == 0) {
					this.$message.error("请选择需要删除的数据！(多选)")
					return
				}
				this.dialogVisibleDel = true
			},
			// 下载导入模板
			async SeconDowload() {
				let {
					data,
					code,
					message
				} = await APPBusinessAuthorityDownloadTemplet({})
				if (code == 0) {
					window.location.href = data
				} else if (code == 101) {
					this.$message({
						type: 'warning',
						message: message
					});
				} else {
					this.$message({
						type: 'error',
						message: message
					});
				}
			},
			//导入
			async InvoiceImport(file) {
				if (file) {
					const loading = this.$loading({
						lock: true,
						text: '上传中...',
						spinner: 'el-icon-loading',
						background: 'rgba(255,255,255,0.3)'
					});
					let formData = new FormData()
					formData.append("file", file)
					let res = await ImportAPPBusinessAuthority(formData)
					if (res.code == 0) {
						this.$message({
							type: 'success',
							message: res.message
						})
						this.APPBusinessAuthorityList()
						loading.close();
					} else if (res.code == 101) {
						this.$message({
							type: 'warning',
							message: res.message
						})
						loading.close();
					} else {
						this.dialogVisiblesdrjg = true
						this.tableDatadrjg = res.data
						this.title = "导入结果"
						this.$message({
							type: 'error',
							message: res.message
						})
						loading.close();
					}
					loading.close();
				}
			},
			CRExport() {

			},
			// 提交
			async APPBusinessAuthoritySubmit() {
				const loading = this.$loading({
					lock: true,
					text: '提交中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let BAMIDs = []
				this.DataListOK.forEach((item, index) => {
					BAMIDs.push(item.BAMID);
				})
				let {
					code,
					data,
					message
				} = await APPBusinessAuthoritySubmit({
					BAMIDs: BAMIDs
				})
				if (code == 0) {
					this.dialogVisibleSubmit = false
					this.$message.success(message)
					this.APPBusinessAuthorityList()
					this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection()

				} else if (code == 1) {
					this.dialogVisibleSubmit = false
					this.title = "提交结果"
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},

			SubmitApply() {
				if (this.DataListOK.length == 0) {
					this.$message.error("请选择需要提交的数据！(多选)")
					return
				}
				this.dialogVisibleSubmit = true
			},
			cancelSubmit() {
				this.dialogVisibleSubmit = false
			},
			dialogOKSubmit() {
				this.DataListOK.forEach((item, index) => {
					this.BAMIDs.push(item.BAMID);
				})
				this.APPBusinessAuthoritySubmit()

			},
			// 撤回
			async APPBusinessAuthorityRevoke(val) {
				const loading = this.$loading({
					lock: true,
					text: '撤回中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let BAMIDs = []
				this.DataListOK.forEach((item, index) => {
					BAMIDs.push(item.BAMID);
				})
				let {
					code,
					data,
					message
				} = await APPBusinessAuthorityRevoke({
					BAMIDs: BAMIDs,
					Reason: val
				})
				if (code == 0) {
					this.dialogVisiblewithdraw = false
					this.$message.success(message)
					this.APPBusinessAuthorityList()
					this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection()
				} else if (code == 1) {
					this.dialogVisiblewithdraw = false
					this.title = "撤回结果"
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			Withdraw() {
				if (this.DataListOK.length == 0) {
					this.$message.error("请选择需要撤回的数据！(多选)")
					return
				}
				let isPromt = this.DataListOK.filter(item => item.Approver);
				if (isPromt.length) {
					this.$prompt('请输入撤回原因', '提示', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
					}).then(({
						value
					}) => {
						this.APPBusinessAuthorityRevoke(value);
					}).catch(() => {});
				} else {
					this.dialogVisiblewithdraw = true
				}
			},
			cancelwithdraw() {
				this.dialogVisiblewithdraw = false
			},
			dialogOKwithdraw() {
				this.APPBusinessAuthorityRevoke()

			},
			// 审批通过
			async APPBusinessAuthorityApprove() {
				const loading = this.$loading({
					lock: true,
					text: '审批中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let BAMIDs = []
				this.DataListOK.forEach((item, index) => {
					BAMIDs.push(item.BAMID);
				})
				let {
					code,
					data,
					message
				} = await APPBusinessAuthorityApprove({
					BAMIDs: BAMIDs,
				})
				if (code == 0) {
					this.dialogVisibleApproved = false
					this.$message.success(message)
					this.APPBusinessAuthorityList()
					this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection()
				} else if (code == 1) {
					this.dialogVisibleApproved = false
					this.title = "审批通过结果"
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			Approved() {
				if (this.DataListOK.length == 0) {
					this.$message.error("请选择需要审核通过的数据！(多选)")
					return
				}
				this.dialogVisibleApproved = true

			},
			cancelApproved() {
				this.dialogVisibleApproved = false
			},
			dialogOKApproved() {
				this.DataListOK.forEach((item, index) => {
					this.BAMIDs.push(item.BAMID);
				})
				this.APPBusinessAuthorityApprove()
			},
			// 驳回
			async APPBusinessAuthorityReject() {
				const loading = this.$loading({
					lock: true,
					text: '驳回中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let BAMIDs = []
				this.DataListOK.forEach((item, index) => {
					BAMIDs.push(item.BAMID);
				})
				let {
					code,
					data,
					message
				} = await APPBusinessAuthorityReject({
					BAMIDs: BAMIDs,
					RejectReason: this.RejectText
				})
				if (code == 0) {
					this.dialogVisibleReject = false
					this.$message.success(message)
					this.APPBusinessAuthorityList()
					this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection()
				} else if (code == 1) {
					this.dialogVisibleReject = false
					this.title = "驳回结果"
					this.dialogVisiblesdrjg = true
					this.tableDatadrjg = data
				} else {
					this.$message.warning(message)
				}
				loading.close()
			},
			//批量下载
			DownloadAll() {
				let BAMIDS = []
				this.DataListOK.forEach((item, index) => {
					BAMIDS.push(item.BAMID)
				})
				if (BAMIDS.length <= 0) {
					this.$message.warning('请选择需要下载的数据')
					return
				}
				this.BusinessAuthorityGeneratePdfList(BAMIDS, 'downloadAll')
			},
			// PDF下载/打印（多行）
			async BusinessAuthorityGeneratePdfList(bamiDs, type) {

				const loading = this.$loading({
					lock: true,
					text: '加载中...',
					spinner: 'el-icon-loading',
					background: 'rgba(255,255,255,0.3)'
				});
				let res = null;
				if (type == 'Print') {
					res = await BusinessAuthorityPrintPdfList({
						bamiDs: bamiDs
					})
				} else {
					res = await BusinessAuthorityGeneratePdfList({
						bamiDs: bamiDs
					})
				}
				if (res) {
					if (type == 'download') {
						let date = new Date()
						let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
						utils.downloadFile(res, `pdf${str}`, "pdf")
					}
					if (type == 'downloadAll') {
						let date = new Date()
						let str = `${date.getFullYear()}-${date.getMonth() + 1}-${date.getDate()}-${date.getTime()}`
						utils.downloadFile(res, `授权书${str}`, "rar", "application/zip")
					}
					if (type == 'Print') {
						utils.downloadFilePdfStream(res, "application/pdf");
					}

				} else {
					// 返回json
					if (type == 'download') {
						this.$message.warning(`导出失败${res.message}`);
					}
					if (type == 'Print') {
						this.$message.warning(`打印失败${res.message}`);
					}
				}
				loading.close();
			},
			Rejectapproval() {
				if (this.DataListOK.length == 0) {
					this.$message.error("请选择需要驳回的数据！(多选)")
					return
				}
				this.dialogVisibleReject = true

			},
			cancelReject() {
				this.dialogVisibleReject = false
			},
			dialogOKReject() {
				this.DataListOK.forEach((item, index) => {
					this.BAMIDs.push(item.BAMID);
				})
				this.APPBusinessAuthorityReject()
			},
			// 审批流程
			async APPBusinessAuthorityGetHostory() {
				// let BAMIDs = []
				// this.DataListOK.forEach((item, index) => {
				//   BAMIDs.push(item.BAMID);
				// })
				// const loading = this.$loading({
				//   lock: true,
				//   text: '加载中...',
				//   spinner: 'el-icon-loading',
				//   background: 'rgba(255,255,255,0.3)'
				// });
				this.loadingTableprocess = true
				let {
					code,
					data,
					message
				} = await APPBusinessAuthorityGetHostory({
					BAMID: this.BAMID,
				})
				if (code == 0) {
					this.dialogVisibleApprovalprocess = true
					this.ApprovalprocessTableData = data
					this.$message.success(message)
					// this.APPBusinessAuthorityList()
					// this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection()
				} else {
					this.$message.warning(message)
				}
				this.loadingTableprocess = false
				// loading.close()
			},
			Approvalprocess() {
				if (this.BAMID == null) {
					this.$message.error("请选择需要操作的数据！(多选)")
					return
				}

				this.APPBusinessAuthorityGetHostory()
			},
			cancelApprovalprocess() {
				this.dialogVisibleApprovalprocess = false
			},
			dialogOKApprovalprocess() {
				this.dialogVisibleApprovalprocess = false
			},
			addClickRow() {
				this.HospitalList('DialogFromList', "", "医院")
				this.GetHospitalType()
			},
			delClickRow() {
				// this.EditorTabelData //准备删除操作数据
				// tableDataEditor
				this.EditorTabelData.map((item, index) => {
					this.tableDataEditor.map((items, indexs) => {
						console.log(item.HPID == items.HPID);
						if (item.HPID == items.HPID) {
							this.tableDataEditor.splice(indexs, 1)
						}
					})
				})
			},


			// 产品线下拉
			async inventoryClassList() {
				let {
					code,
					data
				} = await InventoryClassList({

				})
				if (code == 0) {
					this.FromArrEditor[0].options = []
					this.FromArr[3].options = []

					data.data.map((item, index) => {
						let obj = {
							key: item.InvClass,
							value: item.InvClassName
						}
						this.FromArrEditor[0].options.push(obj)
						this.FromArr[3].options.push(obj)
					})
				}
			},

			// 审批流状态下拉
			async HelperApprovalFlowStatus() {
				let {
					code,
					data,
					message
				} = await HelperApprovalFlowStatus({})
				if (code == 0) {
					this.FromArr[4].options = []
					data.map((item, index) => {
						let obj = {
							key: item.Value,
							value: item.Text
						}
						this.FromArr[4].options.push(obj)
					})
				} else {
					this.$message.warning(message)
				}
			},

			canceldrjg() {
				this.dialogVisiblesdrjg = false
			},
			dialogOKdrjg() {
				this.dialogVisiblesdrjg = false
			},

			// 导出
			Export() {

			},
			// 删除取消
			cancelDel() {
				this.dialogVisibleDel = false
			},
			// 确认删除
			dialogOKDel() {
				this.DataListOK.forEach((item, index) => {
					this.BAMIDs.push(item.BAMID);
				})
				this.APPBusinessAuthorityDelete()
			},
			showclick() {

			},
			hide() {

			},
			select() {
				this.pageIndex = 1
				this.from.ProviderName = this.FromArr[0].modelvalue
				this.from.CusName = this.FromArr[1].modelvalue
				this.from.AuthorityCode = this.FromArr[2].modelvalue
				this.from.InvClass = this.FromArr[3].modelvalue ? this.FromArr[3].modelvalue.join(',') : ''
				this.from.Status = this.FromArr[4].modelvalue
				this.from.CreateTime1 = this.FromArr[6].StartTime
				this.from.CreateTime2 = this.FromArr[6].EndTime
				//this.from.MyApproval = this.FromArr[5].modelvalue
				this.from.MyApproval = this.$refs.btngroup.checkeds == true ? 1 : ""
				this.from.HPName = this.FromArr[7].modelvalue
				this.from.ID = this.FromArr[8].modelvalue
				this.APPBusinessAuthorityList()
			},
			reset() {
				this.FromArr.map((item, index) => {
					if (index == 6) {
						item.StartTime = '';
						item.EndTime = '';
					}
					item.modelvalue = ''
				})
			},
			showclickHP() {

			},
			hideHP() {

			},
			selectHP() {
				this.pageIndexHP = 1
				this.fromHP.hpCode = this.FromArrHP[0].modelvalue
				this.fromHP.hpName = this.FromArrHP[1].modelvalue
				this.fromHP.authorizeStatus = this.FromArrHP[2].modelvalue
				this.fromHP.HosType = this.FromArrHP[3].modelvalue
				this.fromHP.aProvinceID = this.FromArrHP[4].modelvalue
				this.fromHP.aCityID = this.FromArrHP[5].modelvalue
				this.fromHP.aDistrictID = this.FromArrHP[6].modelvalue
				// this.fromHP.CreateTime1 = this.FromArrHP[4].StartTime
				// this.fromHP.CreateTime2 = this.FromArrHP[4].EndTime
				this.HospitalList("DialogFromList", "", "医院")
			},
			resetHP() {
				this.FromArrHP.map((item, index) => {
					if (index == 4) {
						item.StartTime = ''
						item.EndTime = ''
					}
					item.modelvalue = ''
				})
			},
			handleSelectionChange(val) {
				// console.log(val);
				this.DataListOK = val
			},
			handleSelectionChangeEditor(val) {
				this.EditorTabelData = val
			},
			handleSelectionChangeEditorHP(val) {
				this.TableDataEditorDataOK = val
			},
			onRowClick(val) {
				this.BAMID = val.BAMID
				if (!this.BAMID) {
					this.tableDataBottom = []
					return;
				}
				this.APPBusinessAuthorityInfo("BottomTableSee")
			},
			onRowClickHP() {

			},
			onRowClickEditor() {

			},
			handleCurrentChange(PageIndex) {
				this.PageIndex = PageIndex
				this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection()
				this.APPBusinessAuthorityList()
			},
			handleSizeChange(PageSize) {
				this.pageSize = PageSize
				console.log(5666666666666, PageSize)
				this.$refs.refTableCenter.$refs.fileTableSelect.clearSelection()
				this.APPBusinessAuthorityList()
			},
			handleCurrentChangeHP(PageIndex) {
				this.pageIndexHP = PageIndex
				this.HospitalList('DialogFromList', "", "医院")
			},
			handleSizeChangeHP(PageSize) {
				this.pageSizeHP = PageSize
				this.HospitalList('DialogFromList', "", "医院")
			},
			cancelAuthorizationsAdd() {
				this.dialogVisibAuthorizationsAdd = false
			},
			dialogOKAuthorizationsAdd() {
				if (this.TitleEditor == '修改授权申请') {
					this.APPBusinessAuthorityEdit()
				}
				if (this.TitleEditor == '新增授权申请') {
					this.APPBusinessAuthorityAdd()
				}


			},
			cancelAuthorizationsAddHP() {
				this.dialogVisibAuthorizationsAddHP = false
			},
			dialogOKAuthorizationsAddHP() {
				for (const item of this.TableDataEditorDataOK) {
					// 检查缓存中是否已经存在
					// if (this.tableDataEditor.find(EDitem => EDitem.HPID == item.HPID)) {
					// 	// 已经存在说明以前记录过，现在这个就是多余的，直接忽略
					// 	continue;
					// }
					let obj = {
						HPName: item.HPName,
						HPID: item.HPID,
						Doctor: '',
						TechnicalOffices: '',
						SurgeryCountPerYear: '',
						NeedShowOffice: item.NeedShowOffice ? item.NeedShowOffice : 0,
					}
					this.tableDataEditor.push(obj)
				}
				this.dialogVisibAuthorizationsAddHP = false
			}
		},
		watch: {
			dialogVisibAuthorizationsAdd: {
				handler(newVal, OldVal) {
					if (!newVal) {
						this.FromArrEditor.forEach((item, index) => {
							item.disabled = false
							if (index == 3) {
								item.options = []
							}
							if (index == 4) {
								item.StartTime = ''
								item.EndTime = ''
							} else if (index == 5) {
								item.checked = false
							} else {
								item.modelvalue = ''
							}
						})
						this.$refs.refTableCenterApply.$refs.fileTableSelect.clearSelection()
						this.tableDataEditor = []
						this.addClickRowOptional = false
						this.delClickRowOptional = false
						this.AppEditorFalg = false

					} else {
						if (this.TitleEditor == '修改授权申请') {
							this.FromArrEditor[0].disabled = true
							this.FromArrEditor[1].disabled = true
						}
						if (this.TitleEditor == '新增授权申请') {
							if (this.FromArrEditor[0].modelvalue == '' && this.FromArrEditor[1].modelvalue == '') {
								this.FromArrEditor.forEach((item, index) => {
									if (index != 0 && index != 1) {
										item.disabled = true
									}
								})
								this.addClickRowOptional = true
								this.delClickRowOptional = true
								this.AppEditorFalg = false
							} else {
								this.FromArrEditor.forEach((item, index) => {
									if (index != 0 && index != 1) {
										item.disabled = false
									}
								})
								this.addClickRowOptional = false
								this.delClickRowOptional = false
								this.AppEditorFalg = true
							}
						}
					}
				},
				deep: true,
				immediate: false
			},
			dialogVisibAuthorizationsAddHP: {
				handler(newVal, OldVal) {
					if (!newVal) {
						this.$refs.refTableCenterHP.$refs.fileTableSelect.clearSelection()
					}
					// if (newVal) {
					// 	if (this.tableDataEditorHP) {
					// 		// 匹配选中行勾选
					// 		console.log(this.tableDataEditor, 'this.tableDataEditor');
					// 		setTimeout(() => {
					// 			this.tableDataEditorHP.map((item, index) => {
					// 				this.tableDataEditor.map((items, indexs) => {
					// 					if (item.HPID == items.HPID) {
					// 						console.log(this.$refs, 'this.$refs.refTableCenterHP');
					// 						this.$refs.refTableCenterHP.$refs.fileTableSelect
					// 							.toggleRowSelection(item, true);
					// 					}
					// 				})
					// 			})
					// 		}, 100)
					// 	}
					// }
				}
			},
			$route: {
				handler(to, from) {
					let data = JSON.parse(localStorage.getItem("MenusData"))
					data.CusWebMenus.forEach((item, index) => {
						if (item.NodeID == 77) {
							item.Nodes.forEach((items, indexs) => {
								if (items.NodeID == to.query.NodeID) {
									items.Nodes.forEach((itemes, indexes) => {
										if (itemes.NodeID == to.query.MenuID) {
											this.qus = itemes.Buttons
										}
									})
								}
							})
						}
					});
					if (this.qus) {
						this.qus.map((item, index) => {
							if (item.NodeName == 'add') {
								this.qx.add = true
							} else if (item.NodeName == 'edit') {
								this.qx.update = true
							} else if (item.NodeName == 'delete') {
								this.qx.del = true
							} else if (item.NodeName == 'stopif') {
								this.qx.del = true
							} else if (item.NodeName == 'assignment') {
								this.qx.assignment = true
							} else if (item.NodeName == 'enabled') {
								this.qx.enabled = true
							} else if (item.NodeName == 'skip') {
								this.qx.skip = true
							} else if (item.NodeName == 'reset') {
								this.qx.reset = true
							} else if (item.NodeName == 'setting') {
								this.qx.setting = true
							} else if (item.NodeName == 'submit') {
								this.qx.submit = true
							} else if (item.NodeName == 'approval') {
								this.qx.approval = true
							} else if (item.NodeName == 'Download') {
								this.qx.download = true
							}
						})
					}

					// 首页预警处理跳转操作
					let ApplyCode = to.query.ApplyCode //申请单号
					let AuthorityCode = to.query.AuthorityCode //授权书编号
					if (ApplyCode) {
						FromArr[8].modelvalue = ApplyCode
						this.from.ApplyCode = ApplyCode
					}
					if (AuthorityCode) {
						FromArr[2].modelvalue = AuthorityCode
						this.from.AuthorityCode = AuthorityCode
					}
					this.APPBusinessAuthorityList()
				},
				deep: true,
				immediate: true
			}
		},
	}
</script>
<style scoped lang='less'>
	.GCTQ {
		// border: 1px solid red;
		transition: all 0.5s;
	}

	.GCYL {
		//  border: 1px solid rgb(23, 120, 211);
		transition: all 0.5s;
	}

	.Authority {
		width: 100%;
		height: 100%;

		.TopSearch {
			margin: 1px 10px;
			width: 938px;
			height: 254px;
			// border: 1px solid #e5e7ea;
			box-shadow: 0px 1px 4px 2px #e5e7ea;
			border-radius: 0px 0px 0px 0px;
			opacity: 1;
		}

		.BottomTable {
			margin: 32px 10px;
			padding: 10px;
			width: 920px;
			// height: 518px;
			// border: 1px solid #e5e7ea;
			box-shadow: 0px 1px 4px 2px #e5e7ea;
			border-radius: 0px 0px 0px 0px;
			opacity: 1;
		}

		.TableBottom {
			border: 1xp solid red;

			.TBlabel {
				margin-left: 10px;
				margin-top: 5px;
				margin-bottom: 5px;
				width: 100px;
				height: 32px;
				font-size: 14px;
				border: 1px solid rgb(230 230 230);
				line-height: 32px;
				text-align: center;
				cursor: pointer;
				display: inline-block;
				color: rgb(231 29 67);
				background-color: rgb(252 232 236);
			}
		}
	}

	.line {
		width: 960px;
		height: 1px;
		background: #e5e7ea;
		border-radius: 0px 0px 0px 0px;
		opacity: 1;
		margin-top: 20px;
	}

	/deep/.el-textarea .el-textarea__inner {
		width: 880px !important;
	}

	.fixed-model {
		width: 100%;
		height: 275px;
		position: absolute;
		top: 40px;
		left: 0px;
		bottom: 100px;
		background: transparent;
		z-index: 10;
	}
</style>